var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({staticClass:"font-body outline-none rounded-5 transition-all duration-200 cursor-pointer select-none text-center no-underline inline-block",class:[_vm.sizeClass, _vm.variantClass],attrs:{"href":_vm.href}},'a',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }